var map = {
	"./business.svg": 627,
	"./calendar.svg": 628,
	"./corporation.svg": 629,
	"./description.svg": 630,
	"./domain_disabled.svg": 631,
	"./license.svg": 632,
	"./link.svg": 633,
	"./location.svg": 634,
	"./people.svg": 635,
	"./person.svg": 636,
	"./social-facebook.svg": 637,
	"./social-github.svg": 638,
	"./social-linked-in.svg": 639,
	"./social-twitter.svg": 640,
	"./time.svg": 641,
	"./upload.svg": 642
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 624;